// Import the functions you need from the SDKs you need

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAhmio3bXyrPSVo3SV1sktXFrkVjZDpoD0",
  authDomain: "ninadgram-sandbox.firebaseapp.com",
  projectId: "ninadgram-sandbox",
  storageBucket: "ninadgram-sandbox.appspot.com",
  messagingSenderId: "116282098652",
  appId: "1:116282098652:web:cae44ea5db6ba733744519",
  measurementId: "G-JTV7MP1C7P"
};

initializeApp(firebaseConfig);
const projectStorage = getStorage();
const projectFirestore = getFirestore();
const projectAuth = getAuth();

export { projectStorage, projectFirestore, projectAuth }